(function () {


	angular.module('app.widgets')
	.directive('errorLogModal', errorLogModal); 

    errorLogModal.$inject = ['ApiBaseService', "$timeout"];

	function errorLogModal(ApiBaseService, $timeout) {
        return {
            restrict: 'E',
            templateUrl: 'app/widgets/errorLogModal.html',
            scope: {
                itemId: '@',
                titulo: '@',
                tipoDocumentoId: '@',
                emisorId: '@',
                codigoOrigen: '@',
                clave: '@'
            },
            controllerAs: 'vm',
            controller: function($scope){
                var vm = this;

                vm.itemId = $scope.itemId;
                vm.titulo = $scope.titulo;

                vm.tipoDocumentoId = $scope.tipoDocumentoId;
                vm.emisorId = $scope.emisorId;
                vm.codigoOrigen = $scope.codigoOrigen;
                vm.clave = $scope.clave;

                vm.collection = [];
                
                vm.modalName = '#myErrorModal'+vm.itemId;

                angular.element(function () {
                    $timeout(function () {
                        $(vm.modalName).on('shown.bs.modal', function (e) {

                            if(vm.clave)
                            {
                                getComboData(vm.collection, 'api/ErrorLogs/Clave', [vm.clave], 'Error al obtener los emisores.');
                            }
                            else{
                                getComboData(vm.collection, 'api/ErrorLogs/Documento', [vm.tipoDocumentoId, vm.codigoOrigen, vm.emisorId], 'Error al obtener los emisores.');
                            }
                            
                        });     
                     });
                });

                function getComboData(array, apiUrl, params, errorMessage){
                    ApiBaseService.remoteController = apiUrl;
                    var promise = ApiBaseService.getAll(params)
                    .then(function(data){
                        array.splice(0);
                        array.push(...data);
                    })
                    .catch(function(error){
                        $logger.error(errorMessage);
                    }); 
                    
                    return promise;
                };

            }
        }
    }

})();